/**
 * schemas/config/categories.ts
 * Spend categories. Deactivated, never deleted — a category that vanished
 * would orphan every spend that used it.
 */
import { z } from 'zod';

export const categorySchema = z.object({
  id: z.string(),
  /** Short code shown in mono on the ledger, e.g. `FUEL`. */
  code: z.string(),
  display_name: z.string(),
  /** The GL account this maps to, when Finance has set one. */
  gl_hint: z.string().nullable(),
  is_active: z.boolean(),
});
export type Category = z.infer<typeof categorySchema>;

export const categoriesResponseSchema = z.object({ categories: z.array(categorySchema) });

export const categoryCreateSchema = z.object({
  code: z.string().min(1).max(60),
  display_name: z.string().min(1).max(120).optional(),
  gl_hint: z.string().max(60).optional(),
});
export type CategoryCreate = z.infer<typeof categoryCreateSchema>;
